export default __webpack_public_path__ + "static/media/Ownership.ac3b9c64.png";